import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Skills from './components/Skills';
import Education from './components/Education';
import Works from './components/Works';
import Projects from './components/Projects';
import Contact from './components/Contact';
import ProjectDetails from './pages/ProjectDetails';
import ProjectTechnologies from './pages/ProjectTechnologies';

function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Education />
      <Works />
      <Skills />
      <Projects />
      <Contact />
    </>
  );
}

function App() {
  useEffect(() => {
    document.title = 'Ransa N Abewickrama';
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:projectId/details" element={<ProjectDetails />} />
          <Route path="/project/:projectId/technologies" element={<ProjectTechnologies />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
